import { add, listen, qs, qsa, remove } from "@fluorescent/dom";

export default function media(node) {
  const modelEls = qsa("model-viewer", node);

  if (modelEls.length) {
    initModels();
  }

  function initModels() {
    window.Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: setupModelViewerUI,
      },
    ]);

    initShopifyXr();
  }

  function setupModelViewerUI(errors) {
    if (errors) return;

    qsa("model-viewer", node).forEach(model => {
      initCustomModelButtons(model);
    });
  }

  function initCustomModelButtons(model) {
    const viewer = new window.Shopify.ModelViewerUI(model);

    const parentContainer = model.closest(".product__media");
    const poster = qs(".model-poster", parentContainer);
    const closeBtn = qs(".model-close", parentContainer);

    listen(poster, "click", () => {
      add(parentContainer, "model-active");
      viewer.play();
    });

    listen(closeBtn, "click", () => {
      remove(parentContainer, "model-active");
      viewer.pause();
    });
  }

  function initShopifyXr() {
    window.ProductModel = {
      loadShopifyXR() {
        window.Shopify.loadFeatures([
          {
            name: "shopify-xr",
            version: "1.0",
            onLoad: () => this.setupShopifyXR(),
          },
        ]);
      },
      setupShopifyXR: function setupShopifyXR(errors) {
        if (errors) return;

        if (!window.ShopifyXR) {
          listen(document, "shopify_xr_initialized", () => {
            setupShopifyXR();
          });
          return;
        }

        qsa('[id^="ModelJson-"]', document).forEach(modelJSON => {
          window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
          modelJSON.remove();
        });

        window.ShopifyXR.setupXRElements();
      },
    };

    listen(window, "DOMContentLoaded", () => {
      if (window.ProductModel) window.ProductModel.loadShopifyXR();
    });
  }

  function pauseAllMedia() {
    // TODO: Fix external media handling, none of this works otherwise
    // qsa(".js-youtube", document).forEach(video => {
    //   video.contentWindow.postMessage(
    //     '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
    //     "*"
    //   );
    // });

    // qsa(".js-vimeo", document).forEach(video => {
    //   video.contentWindow.postMessage('{"method":"pause"}', "*");
    // });

    qsa("video", node).forEach(video => video.pause());

    qsa("product-model", node).forEach(model => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  return {
    pauseAllMedia,
  };
}
